import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { style: {"min-height":"100vh"} }
const _hoisted_4 = {
  class: "h-100 d-flex flex-column justify-content-center align-items-center",
  style: {"max-width":"95%","margin":"0 auto"}
}
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Select Target Muscle", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, "Select Equipment", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { selected: "" }, "All", -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "row g-0" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://thumbs.dreamstime.com/b/cartoon-background-gym-room-hand-drawn-fitness-center-interior-fitness-79995047.jpg",
    alt: "Exercise Image",
    class: "img-fluid rounded-start",
    width: "125",
    height: "125"
  })
], -1)
const _hoisted_21 = { class: "col-md-8" }
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = { class: "card-title" }
const _hoisted_24 = { class: "card-text" }
const _hoisted_25 = { class: "text-muted" }
const _hoisted_26 = { class: "card-text" }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Add to Program")

import axios, { AxiosResponse } from 'axios'
import { ref, Ref, watch } from 'vue'
import { targetMuscles } from '@/models/targetMuscles'
import { equipment } from '@/models/equipment'
import { useToast } from 'vuestic-ui'
import { ExerciseResultType } from '@/types/exercise-types'
import HomeCarousel from '../components/HomeCarousel.vue'
// add toast when added

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const { init } = useToast()
const chosenTargetMuscle: Ref<string> = ref('')
const chosenEquipment: Ref<string> = ref('')
const resultList: Ref<ExerciseResultType[]> = ref([])
const showModal: Ref<boolean> = ref(false)
const exercise: Ref<ExerciseResultType|undefined> = ref(undefined)
const pageNumber: Ref<number> = ref(1)
const resultSize: Ref<number> = ref(0)
const fullResults: Ref<ExerciseResultType[]> = ref([])
function handleShow(newExercise: ExerciseResultType): void {
  exercise.value = newExercise
  showModal.value = !showModal.value
}
function addToProgram(exercise: ExerciseResultType): void {
  const exerciseToAdd: ExerciseResultType = JSON.parse(JSON.stringify(exercise))
  const programContents: ExerciseResultType[] = JSON.parse(localStorage.getItem('program'))
  if (programContents?.length < 1) {
    localStorage.setItem('program', JSON.stringify([exerciseToAdd]))
    init({ message: 'Added!', color: 'success' })
    showModal.value = false
    return
  }
  if (isPresent(programContents, exerciseToAdd)) {
    init({ message: 'Already on the program', color: 'danger' })
    showModal.value = false
    return
  }
  programContents.push(exerciseToAdd)
  init({ message: 'Success!', color: 'success' })
  showModal.value = false
  return localStorage.setItem('program', JSON.stringify(programContents))
}
function isPresent(exerciseList: ExerciseResultType[], exercise: ExerciseResultType) {
  for (const exerciseItem of exerciseList) {
    if (exerciseItem.id === exercise.id) return true
  }
  return false
}
watch(pageNumber, () => {
  handlePagination()
}, { immediate: true })
function handlePagination() {
  let newResults: ExerciseResultType[] = fullResults.value
  if (pageNumber.value === 1) newResults = newResults.slice(0, (pageNumber.value * 10))
  else newResults = newResults.slice(((pageNumber.value - 1) * 10), ((pageNumber.value) * 10))
  resultList.value = newResults
}
function handleEquipmentFilter() {
  if (chosenEquipment.value === 'All' || chosenEquipment.value === '') return
  let filteredResults: ExerciseResultType[] = fullResults.value
  filteredResults = filteredResults.filter((exercise) => exercise.equipment === chosenEquipment.value)
  fullResults.value = filteredResults
}
async function handleSearch() {
  await axios.get(`https://exercisedb.p.rapidapi.com/exercises/target/${chosenTargetMuscle.value}`,
    {
      headers: {
        'X-RapidAPI-Key': process.env.VUE_APP_X_RAPIDAPI_KEY,
        'X-RapidAPI-Host': 'exercisedb.p.rapidapi.com'
      }
    }
  )
    .then((response: AxiosResponse): void => {
      fullResults.value = response.data
      handleEquipmentFilter()
      resultList.value = fullResults.value
      resultSize.value = fullResults.value.length
      pageNumber.value = 1
      handlePagination()
    })
}

return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_badge = _resolveComponent("va-badge")!
  const _component_va_pagination = _resolveComponent("va-pagination")!
  const _component_va_image = _resolveComponent("va-image")!
  const _component_va_card_actions = _resolveComponent("va-card-actions")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "aria-label": "Search Target Muscle",
            style: {"max-width":"600px"},
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((chosenTargetMuscle).value = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(targetMuscles), (muscle, i) => {
              return (_openBlock(), _createElementBlock("option", {
                key: i,
                value: muscle
              }, _toDisplayString(muscle.replace(/\w+/g,function(w){return w[0].toUpperCase() + w.slice(1).toLowerCase();})), 9, _hoisted_8))
            }), 128))
          ], 512), [
            [_vModelSelect, chosenTargetMuscle.value]
          ])
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _hoisted_12,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            style: {"max-width":"600px"},
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((chosenEquipment).value = $event))
          }, [
            _hoisted_13,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(equipment), (gymEquipment, i) => {
              return (_openBlock(), _createElementBlock("option", {
                key: i,
                value: gymEquipment
              }, _toDisplayString(gymEquipment.replace(/\w+/g,function(w){return w[0].toUpperCase() + w.slice(1).toLowerCase();})), 9, _hoisted_14))
            }), 128))
          ], 512), [
            [_vModelSelect, chosenEquipment.value]
          ])
        ]),
        _hoisted_15,
        _createVNode(_component_va_button, {
          class: "btn btn-primary",
          onClick: handleSearch
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }),
        _hoisted_17,
        (resultList.value?.length<1)
          ? (_openBlock(), _createBlock(HomeCarousel, { key: 0 }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultList.value, (exercise, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card mb-3 w-100",
            key: i,
            onClick: ($event: any) => (handleShow(exercise)),
            style: {"max-width":"800px","max-height":"200px"}
          }, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("h5", _hoisted_23, _toDisplayString(exercise.name.replace(/\w+/g,function(w){return w[0].toUpperCase() + w.slice(1).toLowerCase();})), 1),
                  _createElementVNode("p", _hoisted_24, [
                    _createElementVNode("small", _hoisted_25, _toDisplayString(exercise.target.replace(/\w+/g,function(w){return w[0].toUpperCase() + w.slice(1).toLowerCase();})), 1)
                  ]),
                  _createElementVNode("p", _hoisted_26, [
                    _createVNode(_component_va_badge, {
                      text: exercise.equipment,
                      color: "success"
                    }, null, 8, ["text"])
                  ])
                ])
              ])
            ])
          ], 8, _hoisted_18))
        }), 128)),
        (resultList.value?.length>0)
          ? (_openBlock(), _createBlock(_component_va_pagination, {
              key: 1,
              modelValue: pageNumber.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((pageNumber).value = $event)),
              pages: Math.floor(resultSize.value/10),
              "visible-pages": 2
            }, null, 8, ["modelValue", "pages"]))
          : _createCommentVNode("", true),
        (resultList.value?.length>0)
          ? (_openBlock(), _createElementBlock("br", _hoisted_27))
          : _createCommentVNode("", true),
        (exercise.value)
          ? (_openBlock(), _createBlock(_component_va_modal, {
              key: 3,
              modelValue: showModal.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showModal).value = $event)),
              size: "large",
              "no-padding": ""
            }, {
              content: _withCtx(() => [
                _createVNode(_component_va_image, {
                  ratio: 0.75,
                  src: exercise.value.gifUrl
                }, null, 8, ["ratio", "src"]),
                _createVNode(_component_va_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_button, {
                      flat: "",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (showModal.value=false)),
                      "text-color": "#acb5be"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_28
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_va_button, {
                      color: "primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (addToProgram(exercise.value)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_29
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})